import session from './session'
import format from 'string-format'


export default {

	/**
	 * @param it = {what, id, data}
	 * what_to_update: 'ngs_lib' || 'ngs_explib' || ... <- PgmToolsRest urls for views
	 * id: id (pk)
	 * data: {changed: new_value}
	 * @returns [Promises]
	 */
	update_it(it) {
		return session.patch(format('/{it}/{id}/', {'it': it.what, 'id': it.id}), it.data)
	},

	get(explib_id) {
		return session.get(format('/ngs_explib/{0}/get_full/', explib_id))
	},

	hand_to(handing) {
		return session.post('/ngs_explib/hand_to/', handing)
	},


	create_explibs(year, run_id, lib, sample_type, count){
		lib['sample_type'] = sample_type
		return session.post('/ngs_explib/create_many/', {year: year, run_id: run_id, lib: lib, count: count})
	},

	to_check(explib_ids, sheet_title, rewrite) {
		return session.post('/ngs_explib/to_check/', {explib_ids: explib_ids, sheet_title: sheet_title, rewrite: rewrite})
	},

	add_old_libs_to_run(lib_name, run_id) {
		return session.post('/ngs_explib/add_old_lib_to_run/', {run_id: run_id, lib_names: lib_name})
	},

	move_explibs(run_id, explib_ids) {
		return session.post('/ngs_explib/move_to_an_run/', {run_id: run_id, explib_ids: explib_ids})
	},


	delete_explibs(explib_ids) {
		return session.post('/ngs_explib/delete_many/', {explib_ids: explib_ids})
	},

	change_color(explib_ids, color) {
		return session.post('/ngs_explib/change_color/', {explib_ids: explib_ids, color: color})
	},

	addToAnother(explib_ids, run_id, measuring) {
		return session.post('/ngs_explib/add_to_another/', {explib_ids: explib_ids, run_id: run_id, measuring: measuring})
	}
}